const PLATFORM_ERROR_BASE = 0x0100;
export const PlatformErrorCodes = Object.freeze({
  /**
   * Indicates that Head-End Service Access Token Fetch has Failed.
   */
  PLATFORM_SERVICE_ACCESS_TOKEN_FAILURE: PLATFORM_ERROR_BASE + 0x01,

  /**
   * Indicates that the Authorization Token passed is invalid
   * __Possible Reasons:__
   * - Empty Authorization Bearer
   * - Insufficient Access Claim in Authorization Bearer
   * - Invalid Authorization Bearer, Please check if [{@link PlatformAuthorizer}]  is configured properly.
   */
  PLATFORM_SERVICE_INVALID_ACCESS_TOKEN: PLATFORM_ERROR_BASE + 0x02,

  /**
   * Indicates that the User Access Token Fetch has Failed.
   */
  PLATFORM_SERVICE_USER_ACCESS_TOKEN_FAILURE: PLATFORM_ERROR_BASE + 0x03,

  /**
   * Indicates that a Platform Service call has been interrupted either
   * while performing the request or while reading the response
   */
  PLATFORM_SERVICE_CALL_INTERRUPTED: PLATFORM_ERROR_BASE + 0x04,

  /**
   * Indicates that the Response is Malformed (or) Not of Expected Type
   */
  PLATFORM_SERVICE_MALFORMED_RESPONSE: PLATFORM_ERROR_BASE + 0x05,

  /**
   * Indicates that the Platform Service returned an Error Response.
   */
  PLATFORM_SERVICE_ERROR: PLATFORM_ERROR_BASE + 0x06,
});
